const TARGET_SELECTOR = [
  'input:not([disabled]):not([readonly])',
  'textarea:not([disabled]):not([readonly])',
  'button:not([disabled])',
].join(', ');

const getTargets = (el) => Array.from(el.querySelectorAll(TARGET_SELECTOR))
  .filter((target) => target.offsetParent !== null);

const focusTarget = (el, direction = 1) => {
  const targets = getTargets(el);
  const index = targets.indexOf(document.activeElement);
  const nextIndex = Math.min(Math.max(index + direction, 0), targets.length - 1);
  targets[nextIndex]?.focus();
};

const clickButton = (el, button) => {
  button.click();
  setTimeout(() => {
    const targets = getTargets(el);
    const index = targets.indexOf(button);
    targets[index + 1]?.focus();
  });
};

const handleKeydown = (el, event) => {
  const keyActions = {
    Enter: 'enter',
    ArrowRight: 'next',
    ArrowDown: 'next',
    ArrowLeft: 'previous',
    ArrowUp: 'previous',
  };
  const action = keyActions[event.key];

  if (!action) return;
  if (event.target.tagName === 'TEXTAREA' && event.shiftKey) return;

  if (action === 'previous') {
    event.preventDefault();
    focusTarget(el, -1);
    return;
  }

  if (event.target.tagName === 'BUTTON') {
    event.preventDefault();
    clickButton(el, event.target);
    return;
  }

  event.preventDefault();

  const targets = getTargets(el);
  const index = targets.indexOf(event.target);
  const nextTarget = targets[index + 1];

  if (action === 'enter' && nextTarget?.tagName === 'BUTTON') {
    clickButton(el, nextTarget);
    return;
  }

  focusTarget(el, 1);
};

export default {
  inserted(el) {
    el.__keyboardNavigationHandler__ = (event) => handleKeydown(el, event);
    el.addEventListener('keydown', el.__keyboardNavigationHandler__);
  },

  unbind(el) {
    el.removeEventListener('keydown', el.__keyboardNavigationHandler__);
    delete el.__keyboardNavigationHandler__;
  },
};
